/**
 * Formats structured post location fields (e.g. action_town_hall) for display in cards and detail.
 * Deduplicates when venue name repeats the street/city line (common with Google Places).
 */

function normalizeLoc(s) {
  if (!s) return "";
  return s
    .toLowerCase()
    .replace(/\s+/g, " ")
    .replace(/,\s*usa\s*$/i, "")
    .trim();
}

/** True when name and addr describe the same place (one contains the other), avoiding tiny false positives. */
function isDuplicateLocationPair(name, addr) {
  const na = normalizeLoc(name);
  const nb = normalizeLoc(addr);
  if (!na || !nb) return false;
  if (na === nb) return true;
  const shorter = na.length <= nb.length ? na : nb;
  const longer = na.length > nb.length ? na : nb;
  if (shorter.length < 8) return false;
  if (longer.includes(shorter)) return true;
  return false;
}

export function formatPostLocationSingleLine(post) {
  if (!post) return null;
  const addr = [post.location_address, post.location_city, post.location_state].filter(Boolean).join(", ");
  const name = (post.location_name || "").trim();
  if (name && addr) {
    if (isDuplicateLocationPair(name, addr)) {
      return normalizeLoc(name).length >= normalizeLoc(addr).length ? name : addr;
    }
    return `${name} — ${addr}`;
  }
  if (name) return name;
  if (addr) return addr;
  return null;
}

/** URL to open maps: Apple Maps on iOS Safari, Google Maps elsewhere (web). */
export function getPostLocationMapUrl(post) {
  const query = formatPostLocationSingleLine(post);
  if (!query) return null;
  const encoded = encodeURIComponent(query);
  if (typeof navigator !== "undefined" && /iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    return `https://maps.apple.com/?q=${encoded}`;
  }
  return `https://www.google.com/maps/search/?api=1&query=${encoded}`;
}

export function postHasLocation(post) {
  if (!post) return false;
  return Boolean(
    (post.location_name && String(post.location_name).trim()) ||
      post.location_address ||
      post.location_city ||
      post.location_state
  );
}
